import React, { useEffect, useState } from 'react';

let cachedCreatePortal: any = null;

interface ModalPortalProps {
  children: React.ReactNode;
}

export const ModalPortal: React.FC<ModalPortalProps> = ({ children }) => {
  const [mounted, setMounted] = useState(false);
  const [portalFn, setPortalFn] = useState<any>(() => cachedCreatePortal);

  useEffect(() => {
    setMounted(true);

    if (!cachedCreatePortal) {
      const load = async () => {
        try {
          const mod = await import('react-dom');
          const fn = mod.createPortal || (mod.default && mod.default.createPortal);
          if (typeof fn === 'function') {
            cachedCreatePortal = fn;
            setPortalFn(() => fn);
            return;
          }
        } catch (e) {
          // Fallback to direct esm.sh URL
          try {
            // @ts-ignore
            const mod = await import(/* @vite-ignore */ 'https://esm.sh/react-dom@18.2.0?deps=react@18.2.0');
            const fn = mod.createPortal || (mod.default && mod.default.createPortal);
            if (typeof fn === 'function') {
              cachedCreatePortal = fn;
              setPortalFn(() => fn);
              return;
            }
          } catch (err) {
            console.warn('ModalPortal: createPortal unavailable, rendering inline', err);
          }
        }
      };
      load();
    }
  }, []);

  if (!mounted || typeof document === 'undefined') {
    return null;
  }

  if (portalFn && typeof portalFn === 'function') {
    return portalFn(children, document.body);
  }

  return <>{children}</>;
};

export default ModalPortal;
